import React, { memo, useState } from "react";
import type { ReactElement } from "react";
import Button from "../common/Button";
import Navigation from "./Navigation";
import NavigationList from "../common/NavigationList";
import { motion } from "framer-motion";
import { dataStore } from "../util/useData";
import { InsButton, MetaButton } from "./Footer";
import newLogoSrc from "url:/assets/imgs/new_logo.png?as=webp&width=400";

interface HeaderProps {}

function Header({}: HeaderProps): ReactElement {
  const [hamburgerOpen, setHamburgerOpen] = useState(false);
  const [hover, setHover] = useState(false);

  const isMobile = dataStore((s) => s.isMobile)
  const close = dataStore((s) => s.shouldHeaderHide) && (!isMobile && !hover);

  return (
    <motion.header
      className="z-header"
      initial={{ opacity: 1, y: 0 }}
      animate={{
        opacity: close ? 0 : 1,
        y: close ? "-50%" : 0,
      }}
      exit={{ opacity: 1, y: 0 }}
      transition={{ type: "tween" }}
      onMouseEnter={() => {
        setHover(true);
      }}
      onMouseLeave={() => {
        setHover(false);
      }}
    >
      <img
        src={newLogoSrc}
        alt="Angus T"
        className="h-[80px] md:h-[100px] lg:h-[108px] w-auto"
      />

      <span className="nav-span">
        <NavigationList />
        <span className="flex items-center space-x-[24px]">
          <InsButton />
          <MetaButton />
        </span>
      </span>

      <span className="nav-hamburger">
        <Button onClick={() => setHamburgerOpen(!hamburgerOpen)}>
          {hamburgerOpen ? <HamburgerCloseIcon /> : <HamburgerIcon />}
        </Button>
      </span>

      <Navigation isOpen={hamburgerOpen}>
        <NavigationList onClick={() => setHamburgerOpen(false)} />
        <div className="mx-auto flex items-center justify-around space-x-[24px]">
          <InsButton />
          <MetaButton />
        </div>
      </Navigation>
    </motion.header>
  );
}

export default memo(Header);

const HamburgerIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="35"
    height="35"
    viewBox="0 0 35 35"
    fill="none"
  >
    <path
      d="M5.46875 6.5625H29.5312V8.75H5.46875V6.5625ZM5.46875 16.4062H29.5312V18.5938H5.46875V16.4062ZM5.46875 26.25H29.5312V28.4375H5.46875V26.25Z"
      fill="black"
    />
  </svg>
);

const HamburgerCloseIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
  >
    <path
      d="M24 9.4L22.6 8L16 14.6L9.4 8L8 9.4L14.6 16L8 22.6L9.4 24L16 17.4L22.6 24L24 22.6L17.4 16L24 9.4Z"
      fill="black"
    />
  </svg>
);
